import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { FeatureFlagSelectors } from '@app/core/feature-flags/feature-flag.selectors';
import { FeatureFlags } from '@app/core/feature-flags/feature-flags';
import { LinksService } from '@app/core/links.service';
import { StorageService } from '@app/core/storage.service';
import { OmguiButtonSize, OmguiButtonVariant } from '@omgui/omgui-button/omgui-button.component';

import { SendForgotPasswordEmailGraphQL } from '../send-forgot-password-email-graphql.service';

@Component({
  selector: 'email-sent-confirmation-component',
  templateUrl: './email-sent-confirmation.component.html',
  styleUrls: ['./email-sent-confirmation.component.scss'],
})
export class EmailSentConfirmation implements OnInit {
  contactEmail = '';
  processing = false;
  showResendButton = true;
  isFeatureEnabled$: Observable<boolean>;
  readonly OmguiButtonVariant = OmguiButtonVariant;
  readonly OmguiButtonSize = OmguiButtonSize;
  private resendCount = 0;

  constructor(
    readonly links: LinksService,
    private route: ActivatedRoute,
    private router: Router,
    private sendForgotPasswordEmail: SendForgotPasswordEmailGraphQL,
    private featureFlagSelectors: FeatureFlagSelectors,
    private storageService: StorageService,
  ) {
    this.isFeatureEnabled$ = this.featureFlagSelectors.getFeatureFlag(
      FeatureFlags.OM_ACCOUNT_RECOVERY_ENHANCEMENT,
      false,
    );
  }

  ngOnInit(): void {
    this.contactEmail = this.mfaVerification() ? 'mfasupport@onemedical.com' : 'techsupport@onemedical.com';
  }

  onResendEmail(): void {
    const email = this.storageService.getItem('forgot_password_email');
    const usePreferredEmail = this.storageService.getItem('forgot_password_use_preferred_email') === 'true';

    if (!email) {
      return;
    }

    this.processing = true;
    this.sendForgotPasswordEmail
      .mutate({ email, usePreferredEmail, mfaVerification: this.mfaVerification() })
      .pipe(finalize(() => this.handleResendComplete()))
      .subscribe();
  }

  private handleResendComplete(): void {
    this.processing = false;
    this.incrementResendCount();
  }

  private incrementResendCount(): void {
    this.resendCount++;

    if (this.resendCount >= 2) {
      this.showResendButton = false;
    }
  }

  onTryOtherWay(): void {
    this.router.navigate(['/forgot_password/identity_verification']);
  }

  private mfaVerification(): boolean {
    return this.route.snapshot.queryParams.mfaVerification === 'true';
  }
}
